import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./styles/App.css";

// Pages
import AMA from "./pages/AMA";
import Resume from "./pages/Resume";

function App() {
  return (
    <Router>
      <div className="app">
        <header className="header">
          <div className="logo">Biel's Internet Lair</div>
          <nav>
            <ul>
              <li>
                <Link to="/">AMA</Link>
              </li>
              <li>
                <Link to="/resume">Resume</Link>
              </li>
            </ul>
          </nav>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<AMA />} />
            <Route path="/resume" element={<Resume />} />
          </Routes>
        </main>

        <footer className="footer">
          <p>© {new Date().getFullYear()} Biel Casals. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
